import PropTypes from "prop-types";
import { Alert, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon, List, ListItem, FormControlLabel, Popover, Snackbar, Stack, Switch } from "@mui/material";

import Swal from "sweetalert2";
import { styled } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import { useEffect, useState, useRef } from "react";
import OponentsView from "./components/oponents-view";
import MarketGroupsView from "./components/market-groups-view";
import MarketView from "./components/market-view";
// react-router-dom components
import { useLocation, useSearchParams } from "react-router-dom";
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import { useSoftUIController } from "context";

import { getUserData, getAuthorizationHeader } from "Utils/helpers";
import { getData, postData } from "Utils/server";
import SoftTypography from "components/SoftTypography";
import SoftProgress from "components/SoftProgress";

import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import SoftSelect from "components/SoftSelect";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

var cachedEvent = null;
var cachedMarketGroups = null;
var cachedProviders = null;
var cachedMarketGroupSelected = null;
var cachedPlatform = null;

let waitForSwal = null;
let oddsUuids = [];
let stackItems = [];
let proccessedOdds = [];
let cachedMarketsFilteredSelected = [];
const INITIAL_MARKETS_COUNT = 3;

const marketsPerRowOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
];

const oddsProvidersLayoutOptions = [
  { value: "vertical", label: "Odds Vertical" },
  { value: "horizontal", label: "Odds Horizontal" },
];

const MARKET_SETTINGS_STORAGE_KEY = "fixture-trader-market-settings-v1";

function FixtureTraderView() {
  const abortController = new AbortController();

  const Ref = useRef(null);
  const hasRememberedMarketSettingsRef = useRef(false);
  const hasAppliedDefaultMarketsFilterRef = useRef(false);
  const HIGHER_ROLE = 49;

  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const userData = getUserData();
  const [controller, dispatch] = useSoftUIController();
  const { marketGroups, providers } = controller;
  const [event, setEvent] = useState(null);
  const [marketGroupsFiltered, setMarketGroupsFiltered] = useState(null);
  const [blockedChanges, setBlockedChanges] = useState(false);
  const [markets, setMarkets] = useState(null);
  const [marketsDropDown, setMarketsDropDown] = useState(null);
  const [providersDropDown, setProvidersDropDown] = useState([]);
  const [providersFilteredSelected, setProvidersFilteredSelected] = useState([]);
  const [marketsPerRowSelected, setMarketsPerRowSelected] = useState(marketsPerRowOptions[0]);
  const [oddsProvidersLayoutSelected, setOddsProvidersLayoutSelected] = useState(
    oddsProvidersLayoutOptions[0]
  );
  const [showOddColumn, setShowOddColumn] = useState(true);
  const [showAverageColumn, setShowAverageColumn] = useState(false);
  const [showTopColumn, setShowTopColumn] = useState(false);
  const [rememberMarketSettingsEnabled, setRememberMarketSettingsEnabled] = useState(false);
  const [marketSettingsAnchorEl, setMarketSettingsAnchorEl] = useState(null);
  const [extraColumnView, setExtraColumnView] = useState(false);
  const [scoreboardView, setScoreboardView] = useState(false);
  const [vlCourtView, setVlCourtView] = useState(false);
  const [timelineView, setTimelineView] = useState(false);
  const [liveStatsView, setLiveStatsView] = useState(false);
  const [forceClose, setForceClose] = useState(false);
  const [massClose, setMassClose] = useState(null);
  const [openBackDrop, setOpenBackDrop] = useState(true);
  const [marketGroupSelected, setMarketGroupSelected] = useState(null);
  const [notAvailable, setNotAvailable] = useState(true);
  const [notMarketsAvailable, setNotMarketsAvailable] = useState(false);
  const [fetch, fetching] = useState(false);

  const [notification, setNotification] = useState(true);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [swalBettingCounter, setSwalBettingCounter] = useState("Wait until bets completed...");
  const [showBetsReport, setShowBetsReport] = useState(false);
  const [oddsStyleChange, setOddsStyleChange] = useState();
  const [releaseOperBlocked, setReleaseOperBlocked] = useState(false);
  const [blockedEntities, setBlockedEntities] = useState([]);

  // The state for our timer
  const [timer, setTimer] = useState("00:00:00");
  let roles = userData.roles.sort((a, b) => (a.id > b.id ? 1 : -1));
  let higherRole = roles[0].id;
  const params = [...searchParams.entries()];

  let refreshCycleSecs = higherRole < HIGHER_ROLE ? 10 : 15;

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  async function getParticipantsLogos(event) {
    if (cachedEvent) {
      event.fixtureInfo.participants[0].logo = cachedEvent.fixtureInfo.participants[0].logo;
      event.fixtureInfo.participants[1].logo = cachedEvent.fixtureInfo.participants[1].logo;
      return;
    }

    let getOddsEndpoint = `/api/v1/entities/participantsLogos`;

    let ids = [];
    if (event.fixtureInfo.participants[0].id) ids.push(event.fixtureInfo.participants[0].id);
    if (event.fixtureInfo.participants[1].id) ids.push(event.fixtureInfo.participants[1].id);

    if (ids.length == 0) return;

    let response = await postData(
      getOddsEndpoint,
      { participants: ids },
      {
        Authorization: getAuthorizationHeader(),
      }
    );

    if (response != null) {
      let home = event.fixtureInfo.participants[0].id
        ? response.data.find((item) => item.id == event.fixtureInfo.participants[0].id)
        : null;
      let away = event.fixtureInfo.participants[1].id
        ? response.data.find((item) => item.id == event.fixtureInfo.participants[1].id)
        : null;

      event.fixtureInfo.participants[0].logo = home ? home.logo : null;
      event.fixtureInfo.participants[1].logo = away ? away.logo : null;
    }
  }

  async function initData(fixture_to_init) {
    if (!fixture_to_init) return;
    if (cachedEvent && cachedEvent.fixtureInfo.lastUpdate == fixture_to_init.fixtureInfo.lastUpdate)
      return;

    if (!cachedEvent || `${cachedEvent.fixtureId}` != `${fixture_to_init.fixtureId}`) {
      hasAppliedDefaultMarketsFilterRef.current = false;
      if (!hasRememberedMarketSettingsRef.current) {
        cachedMarketsFilteredSelected = [];
      }
    }

    await sleep(500);

    let event = fixture_to_init;
    // console.log("fixture: ", event);

    await getParticipantsLogos(event);

    let marketsGroupsAvailable = [];
    for (let index = 0; index < event.markets.length; index++) {
      const market = event.markets[index];
      for (let index2 = 0; index2 < market.properties.groups.length; index2++) {
        const group = market.properties.groups[index2];
        if (marketsGroupsAvailable.indexOf(group) > -1) continue;
        marketsGroupsAvailable.push(group);
      }
    }

    let market_groups = cachedMarketGroups
      ? cachedMarketGroups.filter(
          (item) =>
            item.sport_id == fixture_to_init.sport && marketsGroupsAvailable.indexOf(item.id) > -1
        )
      : [];

    market_groups = market_groups.sort((a, b) => a.sort - b.sort);

    if (
      (cachedMarketGroupSelected > 0 ||
        cachedMarketGroupSelected == -1 ||
        cachedMarketGroupSelected == null) &&
      !market_groups.find((mg) => mg.id == cachedMarketGroupSelected)
    ) {
      cachedMarketGroupSelected = 999999;
    }
    // console.log("cachedMarketGroupSelected: ", cachedMarketGroupSelected);
    let market_sorted = event.markets.sort((a, b) => a.properties.sort - b.properties.sort);

    setNotMarketsAvailable(market_sorted.length == 0);

    cachedEvent = fixture_to_init;
    setEvent(event);
    setMarketGroupsFiltered(market_groups);
    setProviderFiltersDropDown(event.providers ? event.providers : []);
    await sleep(100);

    if (cachedMarketGroupSelected)
      marketGroupChange(new Event("marketGroupChange_Custom"), cachedMarketGroupSelected);
    if (fixture_to_init) setNotAvailable(false);
    setOpenBackDrop(false);
  }

  function marketsFiltering(marketGroup) {
    let marketsFiltered = JSON.parse(JSON.stringify(cachedEvent.markets));
    if (marketGroup != null) {
      marketsFiltered = marketsFiltered.filter((market) => {
        return market.properties.groups.indexOf(marketGroup) > -1;
      });
    }

    setMarketFiltersDropDown(marketsFiltered);
    setMarkets(applyCachedMarketFilters(marketsFiltered));
  }

  function setMarketFiltersDropDown(marketsFiltered) {
    setMarketsDropDown(
      marketsFiltered.map((m) => {
        return { value: m.marketId, label: m.name };
      })
    );
  }

  function setProviderFiltersDropDown(providersToFilter) {
    const providerFiltersDropDown = providersToFilter
      ? providersToFilter.map((provider) => {
          return { value: provider, label: provider };
        })
      : [];

    setProvidersDropDown(providerFiltersDropDown);
    setProvidersFilteredSelected((selectedProviders) => {
      if (!selectedProviders || !selectedProviders.length) return [];
      const providersMap = new Set(
        providerFiltersDropDown.map((providerFilter) => {
          return `${providerFilter.value}`;
        })
      );

      return selectedProviders.filter((providerFilter) => {
        return providersMap.has(`${providerFilter.value}`);
      });
    });
  }

  function applyProvidersFiltering(providersToFilter) {
    if (!providersToFilter || !providersToFilter.length) return [];
    if (!providersFilteredSelected || !providersFilteredSelected.length) return providersToFilter;

    const selectedProvidersMap = new Set(
      providersFilteredSelected.map((providerFilter) => {
        return `${providerFilter.value}`;
      })
    );

    return providersToFilter.filter((provider) => {
      return selectedProvidersMap.has(`${provider}`);
    });
  }

  function applyCachedMarketFilters(marketsFiltered) {
    const marketsDropDownMap = new Set(
      marketsFiltered.map((market) => {
        return `${market.marketId}`;
      })
    );

    const marketsDropDownLabelsMap = new Map(
      marketsFiltered.map((market) => {
        return [
          `${market.marketId}`,
          market.name || market.properties.uni_name || `${market.marketId}`,
        ];
      })
    );

    cachedMarketsFilteredSelected = cachedMarketsFilteredSelected.filter((marketFilter) => {
      return marketsDropDownMap.has(`${marketFilter.value}`);
    });

    cachedMarketsFilteredSelected = cachedMarketsFilteredSelected.map((marketFilter) => {
      const marketId = `${marketFilter.value}`;
      return {
        ...marketFilter,
        label: marketsDropDownLabelsMap.get(marketId) || marketFilter.label || marketId,
      };
    });

    if (
      !cachedMarketsFilteredSelected.length &&
      !hasAppliedDefaultMarketsFilterRef.current &&
      !hasRememberedMarketSettingsRef.current
    ) {
      cachedMarketsFilteredSelected = marketsFiltered.slice(0, INITIAL_MARKETS_COUNT).map((market) => {
        return {
          value: market.marketId,
          label: market.name || market.properties.uni_name || `${market.marketId}`,
        };
      });

      hasAppliedDefaultMarketsFilterRef.current = true;
    }

    return marketsFiltered.filter((market) => {
      if (!cachedMarketsFilteredSelected.length) return true;
      return (
        cachedMarketsFilteredSelected.findIndex((marketFilter) => {
          return `${marketFilter.value}` == `${market.marketId}`;
        }) > -1
      );
    });
  }

  function marketsOperatorFiltering(filterOption) {
    let marketsFiltered = JSON.parse(JSON.stringify(cachedEvent.markets));
    if (filterOption == -2) {
      marketsFiltered = marketsFiltered.filter((item) => {
        return item.status == "suspended";
      });
    }

    if (filterOption == -3) {
      marketsFiltered = marketsFiltered.filter((item) => {
        return item.name == null;
      });
    }

    if (filterOption == -4) {
      marketsFiltered = marketsFiltered.filter((item) => {
        let probOdds = item.odds.find(
          (odd) => odd.name == null || item.properties.uni_name == odd.name
        );
        return probOdds ? true : false;
      });
    }

    setMarketFiltersDropDown(marketsFiltered);
    setMarkets(applyCachedMarketFilters(marketsFiltered));
  }

  function filterMarketsByCurrentGroup() {
    if (
      cachedMarketGroupSelected == -2 ||
      cachedMarketGroupSelected == -3 ||
      cachedMarketGroupSelected == -4
    ) {
      marketsOperatorFiltering(cachedMarketGroupSelected);
      return;
    }

    if (cachedMarketGroupSelected == 999999 || cachedMarketGroupSelected == null) {
      marketsFiltering(null);
      return;
    }

    marketsFiltering(cachedMarketGroupSelected);
  }

  async function marketGroupChange(e, marketGroup) {
    e.preventDefault();
    // console.log("marketGroup Pressed: ", marketGroup);
    cachedMarketGroupSelected =
      marketGroup != "betAll" &&
      marketGroup != "betsReport" &&
      marketGroup != "oddsStyle" &&
      marketGroup != "saveBlocked" &&
      marketGroup > 0
        ? marketGroup
        : cachedMarketGroupSelected;
    switch (marketGroup) {
      case -1:
        forceClose ? setForceClose(true) : setForceClose(false);
        if (massClose != null) {
          setMassClose(!massClose);
        } else {
          setMassClose(true);
        }
        break;
      case -2:
        marketsOperatorFiltering(marketGroup);
        break;
      case -3:
        marketsOperatorFiltering(marketGroup);
        break;
      case -4:
        marketsOperatorFiltering(marketGroup);
        break;
      case 999999:
        marketsFiltering(null);
        break;
      case "betAll":
        betAllOdds();
        break;
      case "betsReport":
        showLastBets();
        break;
      case "oddsStyle":
        if (!e.currentTarget) return;
        const selectedOddsStyles = e.currentTarget.value;
        setOddsStyleChange(selectedOddsStyles);
        break;
      case "saveBlocked":
        if (!e.currentTarget) return;
        handleMarketsBlockedConfirmation(e);
        break;
      default:
        marketsFiltering(marketGroup);
        break;
    }
    await sleep(1000);
    //setOpenBackDrop(false);
  }

  async function blockedChange(e, signal) {
    e.preventDefault();
    let blockedEntitiesTmp = [...blockedEntities];
    const operBlockedMarkets = blockedEntitiesTmp ? blockedEntitiesTmp : [];
    let marketIndex = -1;
    switch (signal.type) {
      case "marketChange":
        marketIndex = operBlockedMarkets.findIndex((bm) => bm.uuid == signal.data.uuid);
        if (marketIndex == -1) {
          operBlockedMarkets.push(signal.data);
        } else {
          operBlockedMarkets[marketIndex] = signal.data;
        }
        blockedEntitiesTmp = operBlockedMarkets;
        setBlockedEntities(blockedEntitiesTmp);
        setBlockedChanges(true);
        break;
      case "releaseCompleted":
        setReleaseOperBlocked(false);
        break;
      default:
        break;
    }
    filterMarketsByCurrentGroup();
  }

  async function fetchFixtureData() {
    let platformId = cachedPlatform ? cachedPlatform : userData.defaultPlatform.value;
    let providerId = null;
    let competitionId = null;
    let id = null;
    let type = null;
    let sport = null;

    for (let index = 0; index < params.length; index++) {
      const param = params[index];
      if (param[0] == "platformId") platformId = param[1];
      if (param[0] == "providerId") providerId = param[1];
      if (param[0] == "competitionId") competitionId = param[1];
      if (param[0] == "id") id = param[1];
      if (param[0] == "type") type = param[1];
      if (param[0] == "sport") sport = param[1];
    }

    let getOddsEndpoint = `/api/v2/panel/trader/${platformId}/fixtures/${type}/${sport}`;
    getOddsEndpoint = `${getOddsEndpoint}/${competitionId}/${providerId}/${id}`;

    // let getOddsEndpoint = `/api/v1/keys/${platformId}/fixtures/${type}/${sport}`;
    // getOddsEndpoint = `${getOddsEndpoint}/${competitionId}/${providerId}/${id}`;

    let providerName =
      cachedProviders && cachedProviders.find((p) => p.value == providerId)
        ? cachedProviders.find((p) => p.value == providerId)["label"]
        : "";
    let response = await getData(getOddsEndpoint, {
      Authorization: getAuthorizationHeader(),
    });

    if (response != null) {
      let fixture_api = response.data;
      if (response.data) {
        let dt = new Date(fixture_api.fixture.startDate).toLocaleString("en-GB");
        let matchResultMarket = null;
        fixture_api = createFixtureData(
          fixture_api.fixture.eventId,
          providerId,
          providerName,
          fixture_api.fixture.sport.id,
          fixture_api.fixture.region.providerName,
          fixture_api.fixture.competition.providerName,
          fixture_api.type,
          dt,
          fixture_api.fixture.participants[0].providerName,
          fixture_api.fixture.participants[1].providerName,
          fixture_api.fixture.status,
          fixture_api.filtered,
          matchResultMarket
            ? {
                name: matchResultMarket.name,
                odds: matchResultMarket.odds,
              }
            : { name: "", odds: null },
          fixture_api.markets.filter((item) => item.status !== "deleted"),
          [{ vlcourt: false }, { stats: true }, { timeline: true }, { scoreboard: true }],
          fixture_api.live,
          fixture_api.fixture,
          fixture_api.oddsBlocked
        );

        fixture_api.providers = response.data.fixture.statuses
          ? response.data.fixture.statuses
              .filter((s) => {
                const normalizedStatus =
                  s && s.status ? `${s.status}`.toLowerCase().replace(/[^a-z]/g, "") : "";

                return normalizedStatus !== "coveragelost" && normalizedStatus !== "finished";
              })
              .map((s) => {
                const cachedProvider = cachedProviders
                  ? cachedProviders.find((p) => p.value == s.providerId)
                  : null;

                return cachedProvider ? cachedProvider.label : s.providerId;
              })
          : [];

        fixture_api.providers = fixture_api.providers.sort();

        //console.log("fixture to init: ", fixture_api);
        initData(fixture_api);
      } else {
        setNotAvailable(true);
      }
    } else {
      setNotAvailable(true);
    }
    await sleep(100);
    fetching(false);
  }

  function createFixtureData(
    fixtureId: number,
    provider_id: number,
    providerName: string,
    sport: string,
    region: string,
    league: string,
    type: string,
    date: string,
    home: string,
    away: string,
    status: string,
    filtered: boolean,
    matchresult: object,
    markets: array,
    products: array,
    live: object,
    fixtureInfo: object,
    blockedOdds: array
  ) {
    return {
      fixtureId,
      provider_id,
      providerName,
      sport,
      region,
      league,
      type,
      date,
      home,
      away,
      status,
      filtered,
      matchresult,
      markets,
      products,
      live,
      fixtureInfo,
      blockedOdds,
    };
  }

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      setTimer(
        (hours > 9 ? hours : "0" + hours) +
          ":" +
          (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    }
    if (total < 0) clearTimer(getDeadTime());
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    fetching(true);
    setTimer("00:00:" + refreshCycleSecs);

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;

    fetchFixtureData();
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + refreshCycleSecs);
    return deadline;
  };

  
  const openPreStats = (e, statsId) => {
    e.preventDefault();

    let protocol = window.location.protocol;
    let hostname = window.location.hostname;
    let port = window.location.hostname == "localhost" ? "3000" : "5030";
    let route = "/stats";
    let params = `?apikey=1f5abd3dfef60f2611e30b946f7f1be7&statsid=${statsId}`;
    let url = protocol + "//" + hostname + ":" + port + route + params;
    window.open(
      url.toString(),
      "_blank",
      "toolbar=no, location=no, directories=no, status=no, menubar=no, width=780,noreferrer"
    );
  };

  const oponentsHandleClick = (e, item) => {
    e.preventDefault();
    //console.log(item);

    if (!cachedEvent && !cachedEvent.live) return;

    switch (item) {
      case "scoreboard":
        if (!cachedEvent.live.scoreBoard) return;
        setScoreboardView(!scoreboardView);
        break;
      case "timeline":
        if (!cachedEvent.live.timeline || !cachedEvent.live.timeline.length > 0) return;
        if (!cachedEvent.live.timeline.filter((te) => te.participant).length > 0) return;
        setTimelineView(!timelineView);
        break;
      case "vlcourt":
        if (
          !cachedEvent.fixtureInfo.virtualCourtId ||
          cachedEvent.fixtureInfo.status != "In progress"
        )
          return;
        setVlCourtView(!vlCourtView);
        break;
      case "liveStats":
        if (!cachedEvent.live.scoreBoard) return;
        setLiveStatsView(!liveStatsView);
        break;
      case "stats":
        if (!cachedEvent.fixtureInfo.statsId) return;
        openPreStats(new Event("openStats"), cachedEvent.fixtureInfo.statsId);
        break;
      default:
        break;
    }
  };

  const changeMarketsFilters = (item) => {
    const selectedMarkets = item ? item : [];
    cachedMarketsFilteredSelected = selectedMarkets;
    filterMarketsByCurrentGroup();

    if (rememberMarketSettingsEnabled) {
      rememberMarketSettings(false, { selectedMarkets });
    }
  };

  const changeProvidersFilters = (item) => {
    setProvidersFilteredSelected(item ? item : []);
  };

  const changeMarketsPerRow = (item) => {
    setMarketsPerRowSelected(item ? item : marketsPerRowOptions[0]);
  };

  const changeOddsProvidersLayout = (item) => {
    setOddsProvidersLayoutSelected(item ? item : oddsProvidersLayoutOptions[0]);
  };

  const changeShowOddColumn = (_event, checked) => {
    setShowOddColumn(checked);
  };

  const changeShowAverageColumn = (_event, checked) => {
    setShowAverageColumn(checked);
  };

  const changeShowTopColumn = (_event, checked) => {
    setShowTopColumn(checked);
  };

  const openMarketSettingsMenu = (event) => {
    setMarketSettingsAnchorEl(event.currentTarget);
  };

  const closeMarketSettingsMenu = () => {
    setMarketSettingsAnchorEl(null);
  };

  const rememberMarketSettings = (shouldCloseMenu = false, overrides = {}) => {
    const selectedMarkets = Array.isArray(overrides.selectedMarkets)
      ? overrides.selectedMarkets
      : cachedMarketsFilteredSelected;

    const selectedProviders = Array.isArray(overrides.selectedProviders)
      ? overrides.selectedProviders
      : providersFilteredSelected;

    const settingsPayload = {
      marketsPerRow: marketsPerRowSelected
        ? marketsPerRowSelected.value
        : marketsPerRowOptions[0].value,
      oddsProvidersLayout: oddsProvidersLayoutSelected
        ? oddsProvidersLayoutSelected.value
        : oddsProvidersLayoutOptions[0].value,
      rememberEnabled: true,
      showOddColumn,
      showAverageColumn,
      showTopColumn,
      selectedMarketIds: selectedMarkets
        ? selectedMarkets.map((marketFilter) => marketFilter.value)
        : [],
      selectedProviderValues: selectedProviders
        ? selectedProviders.map((providerFilter) => providerFilter.value)
        : [],
    };

    try {
      localStorage.setItem(MARKET_SETTINGS_STORAGE_KEY, JSON.stringify(settingsPayload));
      if (shouldCloseMenu) closeMarketSettingsMenu();
    } catch (err) {
      console.error("Unable to remember market settings", err);
    }
  };

  const clearRememberedMarketSettings = () => {
    try {
      localStorage.removeItem(MARKET_SETTINGS_STORAGE_KEY);
    } catch (err) {
      console.error("Unable to clear remembered market settings", err);
    }
  };

  const changeRememberMarketSettings = (_event, checked) => {
    setRememberMarketSettingsEnabled(checked);

    if (checked) {
      rememberMarketSettings(false);
      return;
    }

    clearRememberedMarketSettings();
  };

  const loadRememberedMarketSettings = () => {
    try {
      const rememberedSettingsRaw = window.localStorage.getItem(MARKET_SETTINGS_STORAGE_KEY);
      if (!rememberedSettingsRaw) return;

      hasRememberedMarketSettingsRef.current = true;
      hasAppliedDefaultMarketsFilterRef.current = true;

      const rememberedSettings = JSON.parse(rememberedSettingsRaw);

      setRememberMarketSettingsEnabled(
        typeof rememberedSettings.rememberEnabled == "boolean"
          ? rememberedSettings.rememberEnabled
          : true
      );

      const rememberedMarketsPerRow = marketsPerRowOptions.find((option) => {
        return `${option.value}` == `${rememberedSettings.marketsPerRow}`;
      });

      if (rememberedMarketsPerRow) {
        setMarketsPerRowSelected(rememberedMarketsPerRow);
      }

      const rememberedOddsLayout = oddsProvidersLayoutOptions.find((option) => {
        return `${option.value}` == `${rememberedSettings.oddsProvidersLayout}`;
      });

      if (rememberedOddsLayout) {
        setOddsProvidersLayoutSelected(rememberedOddsLayout);
      }

      if (typeof rememberedSettings.showOddColumn == "boolean") {
        setShowOddColumn(rememberedSettings.showOddColumn);
      }

      if (typeof rememberedSettings.showAverageColumn == "boolean") {
        setShowAverageColumn(rememberedSettings.showAverageColumn);
      }

      if (typeof rememberedSettings.showTopColumn == "boolean") {
        setShowTopColumn(rememberedSettings.showTopColumn);
      }

      if (Array.isArray(rememberedSettings.selectedMarketIds)) {
        cachedMarketsFilteredSelected = rememberedSettings.selectedMarketIds.map((marketId) => {
          return { value: marketId, label: `${marketId}` };
        });
      }

      if (Array.isArray(rememberedSettings.selectedProviderValues)) {
        setProvidersFilteredSelected(
          rememberedSettings.selectedProviderValues.map((providerValue) => {
            return { value: providerValue, label: `${providerValue}` };
          })
        );
      }
    } catch (err) {
      console.error("Unable to load remembered market settings", err);
    }
  };

  useEffect(() => {
    if (!rememberMarketSettingsEnabled) return;

    rememberMarketSettings(false);
  }, [
    rememberMarketSettingsEnabled,
    marketsPerRowSelected,
    oddsProvidersLayoutSelected,
    showOddColumn,
    showAverageColumn,
    showTopColumn,
    providersFilteredSelected,
  ]);

  const clearSwal = () => {
    waitForSwal.close();
    waitForSwal = null;
    stackItems = [];
  };

  async function betAllOdds() {
    oddsUuids = [];
    proccessedOdds = [];
    
    for (let index = 0; index < cachedEvent.markets.length; index++) {
      const market = cachedEvent.markets[index];
      for (let index2 = 0; index2 < market.odds.length; index2++) {
        const odd = market.odds[index2];
        oddsUuids.push(odd.properties.uuid);
      }
    }

    setSwalBettingCounter(`Wait until ${oddsUuids.length} bets will be placed...`);

    Swal.fire({
      title: `Ready to Bet`,
      html: `You are going to place bets for ${oddsUuids.length} Odds.
              </br></br>
              Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, Place them!",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleAutoPlaceBetsFunctionality();
        for (let index = 0; index < oddsUuids.length; index++) {
          const uuid = oddsUuids[index];
          let response = await placeBet(uuid);
          if (response) {
            Swal.getTitle().textContent = `Wait until ${oddsUuids.length} bets will be placed...`;
            Swal.getHtmlContainer().textContent = `${index + 1}/${oddsUuids.length} Bet Processed`;
            Swal.hideLoading();
            setApiresponse("success");
            setApiResponseMsg(`${index + 1}/${oddsUuids.length} Bet Processed`);
            setNotification(true);
            stackItems.push({ id: uuid, response: "success", indexing: index });
            proccessedOdds.push({ id: uuid, response: "success", indexing: index });
          } else {
            Swal.getTitle().textContent = `Wait until ${oddsUuids.length} bets will be placed...`;
            Swal.getHtmlContainer().textContent = `${index + 1}/${oddsUuids.length} Bet Processed`;
            Swal.hideLoading();
            setApiresponse("error");
            setApiResponseMsg(`${index + 1}/${oddsUuids.length} Bet Processed`);
            stackItems.push({ id: uuid, response: "error", indexing: index });
            proccessedOdds.push({ id: uuid, response: "error", indexing: index });
            setNotification(true);
          }

          if (stackItems.length > 10) {
            stackItems.shift();
          }
        }
        if (waitForSwal) {
          Swal.update({
            icon: "warning",
            confirmButtonText: "ok",
          });
          Swal.getTitle().textContent = `${oddsUuids.length} bets placed...`;
          Swal.getHtmlContainer().textContent = `${oddsUuids.length}/${
            oddsUuids.length
          } Bet Processed. 
           ${proccessedOdds.filter((si) => si.response == "success").length} Accepted, and ${
            proccessedOdds.filter((si) => si.response == "error").length
          } Rejected `;
        }
      }
    });
  }

  function showLastBets() {
    setShowBetsReport(true);
    //console.log(proccessedOdds);
  }

  const handleAutoPlaceBetsFunctionality = () => {
    if (waitForSwal) return;
    waitForSwal = Swal.fire({
      title: "Auto bet for all odds begins... ",
      html: swalBettingCounter,
      confirmButtonText: "Stop Betting proccess",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
      },
      willClose: clearSwal,
      allowOutsideClick: false,
    });
  };

  async function placeBet(oddUuid) {
    const userData = getUserData();
    let getOddsEndpoint = `/api/v1/bets/create`;
    let platformId = userData.defaultPlatform.value;
    //console.log(userData, oddUuid);
    let response = await postData(
      getOddsEndpoint,
      { currency_id: 1, amount: 1, odds: [oddUuid], platformId: platformId },
      {
        Authorization: getAuthorizationHeader(),
      }
    );
    if (response != null) {
      return true;
    } else {
      return false;
    }
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  function renderStackedAlerts() {
    return stackItems.map((item, index) => {
      return (
        <Snackbar
          sx={{ position: "relative !important", top: "", right: "" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          key={"topright" + item.id + index}
          open={notification}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={`${item.response}`}
            sx={{ width: "100%" }}
            className={`api-${item.response}-notifications`}
          >
            {item.response == "success"
              ? `Bet #${item.indexing + 1}/${oddsUuids.length} has been placed!`
              : `Bet #${item.indexing + 1}/${
                  oddsUuids.length
                } not Accepted. Something goes wrong try again please!`}
          </Alert>
        </Snackbar>
      );
    });
  }

  const handleMarketsBlockedConfirmation = (e) => {
    e.preventDefault();

    Swal.fire({
      title: `Confirmation`,
      html: `You are going to save the changes you have done to Blocked Markets and Odds."</b></br> </br> Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, Procceed!",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setMarketsBlocked(e);
      }
    });
  };

  async function setMarketsBlocked(e) {
    e.preventDefault();
    const userData = getUserData();

    Swal.fire({
      title: "We proccess your request! ",
      html: "Wait for few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
        let setBlockedEndpoint = `/api/v2/panel/filters/markets/blocked`;

        let response = await postData(
          setBlockedEndpoint,
          blockedEntities.map((m) => {
            return {
              platform_id: cachedPlatform ? cachedPlatform : userData.defaultPlatform.value,
              provider_id: cachedEvent.provider_id,
              fixture_id: cachedEvent.fixtureId,
              uuid: m.uuid,
              status: m.status,
              odds: m.odds,
            };
          }),
          { Authorization: getAuthorizationHeader() },
          null,
          abortController ? { signal: abortController.signal } : null
        );

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            Swal.clickConfirm();
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Request Sent!", `Blocked Markets and Odds for this Fixture sent!`, "success");
      }
      if (result.isDenied) {
        Swal.fire(
          "Error!",
          `Blocked Markets and Odds for this Fixture didnt sent! Please try again later!`,
          "error"
        );
      }
      setReleaseOperBlocked(true);
      setBlockedChanges(false);
      setBlockedEntities([]);
    });
  }

  useEffect(() => {
    if (timelineView || vlCourtView || liveStatsView) setExtraColumnView(true);
    if (!timelineView && !vlCourtView && !liveStatsView) setExtraColumnView(false);
  }, [timelineView, vlCourtView, liveStatsView]);

  useEffect(() => {
    //console.log("fixture: ", window.fixture);
    if (marketGroups) {
      if (window.fixture) {
        const userData = getUserData();
        cachedPlatform = userData.defaultPlatform.value;
        initData(window.fixture);
      } else {
      }
      cachedMarketGroups = marketGroups;
    }
  }, [marketGroups]);

  useEffect(() => {
    if (providers) {
      cachedProviders = providers;
      setOpenBackDrop(true);
      clearTimer(getDeadTime());
    }
  }, [providers]);

  useEffect(() => {
    loadRememberedMarketSettings();
  }, []);

  useEffect(() => {
    return () => {
      // console.log("living page...");
      if (abortController) {
        // console.log("abortController landing page");
        abortController.abort();
      }
    };
  }, []);

  const providersFiltered =
    event && event.providers ? applyProvidersFiltering(event.providers) : [];
  const selectedMarketsPerRow = marketsPerRowSelected ? marketsPerRowSelected.value : 1;
  const selectedOddsProvidersLayout = oddsProvidersLayoutSelected
    ? oddsProvidersLayoutSelected.value
    : "vertical";
  const marketsToRender =
    markets && event && event.providers
      ? markets.map((m, index) => {
          return {
            market: { ...m, providers: providersFiltered },
            index,
          };
        })
      : [];
  const marketsColumnsCount = Math.max(1, selectedMarketsPerRow);
  const marketsColumns = Array.from({ length: marketsColumnsCount }, () => []);
  const marketsColumnsHeights = Array.from({ length: marketsColumnsCount }, () => 0);

  const getMarketRenderWeight = (market) => {
    if (!market) return 1;

    const oddsCount = market.odds && Array.isArray(market.odds) ? market.odds.length : 0;
    const providersCount =
      market.providers && Array.isArray(market.providers) ? market.providers.length : 0;

    let weight = 6 + oddsCount;

    if (selectedOddsProvidersLayout == "horizontal") {
      weight += Math.min(6, Math.ceil(providersCount / 2));
    } else {
      weight += Math.min(4, providersCount);
    }

    return weight;
  };

  for (let index = 0; index < marketsToRender.length; index++) {
    let shortestColumnIndex = 0;

    for (let columnIndex = 1; columnIndex < marketsColumnsCount; columnIndex++) {
      if (marketsColumnsHeights[columnIndex] < marketsColumnsHeights[shortestColumnIndex]) {
        shortestColumnIndex = columnIndex;
      }
    }

    const marketItem = marketsToRender[index];
    marketsColumns[shortestColumnIndex].push(marketItem);
    marketsColumnsHeights[shortestColumnIndex] += getMarketRenderWeight(marketItem.market);
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Stack
        spacing={1}
        direction="column"
        style={{ position: "fixed", top: "10px", right: "10px", zIndex: "10000" }}
      >
        {renderStackedAlerts()}
      </Stack>
      <Dialog
        open={showBetsReport}
        onClose={() => setShowBetsReport(false)}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Last Bets Report</DialogTitle>
        <DialogContent dividers={true}>
          <List>
            {[...proccessedOdds].map((odd) => {
              return (
                <ListItem key={odd.id} disablePadding>
                  <span style={{ fontSize: "18px" }}>{odd.id} - </span>
                  {"   "}
                  <span
                    style={{ fontSize: "16px", color: odd.response == "error" ? "red" : "green" }}
                  >
                    {odd.response == "error" ? " (rejected)" : " (accepted)"}
                  </span>{" "}
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowBetsReport(false)}>ok</Button>
        </DialogActions>
      </Dialog>
      <SoftBox my={1}>
        <Card sx={{ height: "85vh !important", overflow: "hidden" }}>
          <SoftBox
            display=" flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="flex-start"
            p={1}
            sx={{ height: "100%", minHeight: 0, overflow: "hidden" }}
          >
            <Grid container sx={{ display: notAvailable ? (openBackDrop ? "none" : "") : "none" }}>
              {" "}
              <SoftTypography sx={{ textAlign: "center", width: "100%", fontSize: "1rem" }}>
                Event is not available any more.
              </SoftTypography>
            </Grid>
            <Grid container sx={{ display: openBackDrop ? "" : "none" }}>
              <div style={{ textAlign: "center", width: "100%" }}>
                <CircularProgress color="inherit" />
              </div>
            </Grid>

            <Grid sx={{ display: notAvailable ? "none" : "" }} container id={"fixture-header"}>
              <Grid
                item
                sx={{
                  position: "absolute",
                  top: "185px",
                  left: "160px",
                  scale: "40%",
                  zIndex: "10",
                  color: "#fff",
                  display: fetch ? "" : "none",
                }}
              >
                <CircularProgress fontSize="0.5rem" color="inherit" />
              </Grid>
              <OponentsView
                event={event}
                openBackDrop={fetch}
                informParent={oponentsHandleClick}
              ></OponentsView>
            </Grid>
            <Grid
              sx={{
                display: notAvailable ? "none" : "",
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
                flexDirection: "column",
                flexWrap: "nowrap",
              }}
              container
              id="fixture-body"
            >
              <Grid container sx={{ display: notMarketsAvailable ? "" : "none" }}>
                {" "}
                <SoftTypography sx={{ textAlign: "center", width: "100%", fontSize: "1rem" }}>
                  There are no markets available at the moment.
                </SoftTypography>
              </Grid>
              <Grid
                container
                sx={{ flex: 1, minHeight: 0, overflow: "hidden", flexWrap: "nowrap" }}
              >
                <Grid
                  id="mainColumn"
                  item
                  sm={extraColumnView ? 10 : 12}
                  sx={{ minHeight: 0, display: "grid", gridTemplateRows: "auto minmax(0, 1fr)" }}
                >
                  <Grid
                    container
                    id="market-groups-holder"
                    sx={{ display: notMarketsAvailable ? "none" : "" }}
                  >
                    <MarketGroupsView
                      groups={marketGroupsFiltered}
                      selectedGroup={cachedMarketGroupSelected}
                      informParent={marketGroupChange}
                      blockChanges={blockedChanges}
                      onMarketSettingsClick={openMarketSettingsMenu}
                    ></MarketGroupsView>
                    <SoftBox py={0} px={0} sx={{ width: "100%" }}>
                      <Popover
                        id="market-settings-menu"
                        open={Boolean(marketSettingsAnchorEl)}
                        onClose={closeMarketSettingsMenu}
                        anchorEl={marketSettingsAnchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        PaperProps={{
                          sx: {
                            width: "min(94vw, 980px)",
                            maxHeight: "72vh",
                            overflow: "auto",
                            p: 1.5,
                            backgroundColor: "#fff",
                            height: "50%",
                          },
                        }}
                      >
                        <SoftBox
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                          }}
                        >
                          <SoftBox sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <SoftTypography variant="button" fontWeight="medium">
                              Market Settings
                            </SoftTypography>
                            <FormControlLabel
                              sx={{
                                m: 0,
                                height: "30px",
                                alignItems: "center",
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "0.75rem",
                                  lineHeight: 1,
                                },
                              }}
                              control={
                                <Switch
                                  id="remember-market-settings"
                                  checked={rememberMarketSettingsEnabled}
                                  onChange={changeRememberMarketSettings}
                                />
                              }
                              label={
                                "Remember (" + (rememberMarketSettingsEnabled ? "On" : "Off") + ")"
                              }
                            />
                          </SoftBox>
                          <SoftBox sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Button
                              size="small"
                              onClick={closeMarketSettingsMenu}
                              sx={{ minWidth: "auto", textTransform: "none", p: "2px 8px" }}
                            >
                              Close
                            </Button>
                          </SoftBox>
                        </SoftBox>
                        <SoftBox
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", lg: "repeat(2, minmax(320px, 1fr))" },
                            gap: "12px",
                          }}
                        >
                          <SoftBox>
                            <SoftTypography variant="caption">Select Markets: </SoftTypography>
                            <SoftSelect
                              id="markets-filters"
                              size="small"
                              value={cachedMarketsFilteredSelected}
                              options={marketsDropDown ? marketsDropDown : []}
                              isMulti={true}
                              className="multiselectwrap"
                              onChange={changeMarketsFilters}
                            />
                          </SoftBox>
                          <SoftBox>
                            <SoftTypography variant="caption">Select Providers: </SoftTypography>
                            <SoftSelect
                              id="providers-filters"
                              size="small"
                              value={providersFilteredSelected}
                              options={providersDropDown ? providersDropDown : []}
                              isMulti={true}
                              className="multiselectwrap"
                              onChange={changeProvidersFilters}
                            />
                          </SoftBox>
                          <SoftBox>
                            <SoftTypography variant="caption">Markets / row: </SoftTypography>
                            <SoftSelect
                              id="markets-per-row"
                              size="small"
                              value={marketsPerRowSelected}
                              options={marketsPerRowOptions}
                              isMulti={false}
                              isClearable={false}
                              onChange={changeMarketsPerRow}
                            />
                          </SoftBox>
                          <SoftBox>
                            <SoftTypography variant="caption">Odds Layout: </SoftTypography>
                            <SoftSelect
                              id="odds-providers-layout"
                              size="small"
                              value={oddsProvidersLayoutSelected}
                              options={oddsProvidersLayoutOptions}
                              isMulti={false}
                              isClearable={false}
                              onChange={changeOddsProvidersLayout}
                            />
                          </SoftBox>
                          <SoftBox sx={{ gridColumn: { xs: "span 1", lg: "span 2" } }}>
                            <SoftTypography variant="caption">Columns Visibility:</SoftTypography>
                            <SoftBox
                              sx={{ display: "flex", flexWrap: "wrap", gap: "12px", mt: 0.25 }}
                            >
                              <FormControlLabel
                                sx={{
                                  m: 0,
                                  height: "34px",
                                  alignItems: "center",
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "0.75rem",
                                    lineHeight: 1,
                                  },
                                }}
                                control={
                                  <Switch
                                    id="show-odd-column"
                                    checked={showOddColumn}
                                    onChange={changeShowOddColumn}
                                  />
                                }
                                label={`Odd (${showOddColumn ? "Show" : "Hide"})`}
                              />
                              <FormControlLabel
                                sx={{
                                  m: 0,
                                  height: "34px",
                                  alignItems: "center",
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "0.75rem",
                                    lineHeight: 1,
                                  },
                                }}
                                control={
                                  <Switch
                                    id="show-average-column"
                                    checked={showAverageColumn}
                                    onChange={changeShowAverageColumn}
                                  />
                                }
                                label={`Average (${showAverageColumn ? "Show" : "Hide"})`}
                              />
                              <FormControlLabel
                                sx={{
                                  m: 0,
                                  height: "34px",
                                  alignItems: "center",
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "0.75rem",
                                    lineHeight: 1,
                                  },
                                }}
                                control={
                                  <Switch
                                    id="show-top-column"
                                    checked={showTopColumn}
                                    onChange={changeShowTopColumn}
                                  />
                                }
                                label={`Highest (${showTopColumn ? "Show" : "Hide"})`}
                              />
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                      </Popover>
                    </SoftBox>
                  </Grid>
                  <Grid
                    container
                    id="markets-holder"
                    style={{
                      display: notMarketsAvailable ? "none" : "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      gap: "6px",
                      width: "100%",
                      flex: "1 1 auto",
                      minHeight: 0,
                      height: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {marketsColumns.map((columnMarkets, columnIndex) => {
                      return (
                        <SoftBox
                          key={`markets-column-${columnIndex}`}
                          sx={{
                            flex: `0 0 calc((100% - ${(marketsColumnsCount - 1) * 6}px) / ${marketsColumnsCount})`,
                            minWidth: 0,
                            display: "flex",
                            flexDirection: "column",
                            gap: "6px",
                          }}
                        >
                          {columnMarkets.map((marketItem) => {
                            const market = marketItem.market;
                            return (
                              <SoftBox key={market.marketId + "-" + marketItem.index} sx={{ minWidth: 0 }}>
                              <MarketView
                                market={market}
                                massClose={massClose}
                                oddsStyle={oddsStyleChange}
                                informParent={blockedChange}
                                releaseOperBlocked={releaseOperBlocked}
                                oddsProvidersLayout={selectedOddsProvidersLayout}
                                marketsPerRow={selectedMarketsPerRow}
                                showOddColumn={showOddColumn}
                                showAverageColumn={showAverageColumn}
                                showTopColumn={showTopColumn}
                              ></MarketView>
                              </SoftBox>
                            );
                          })}
                        </SoftBox>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid id="rightColumn" item sm={extraColumnView ? 2 : 0}>
                  <Card
                    sx={{
                      height: "calc(100vh - 390px) !important",
                      margin: "33px 10px",
                      backgroundColor: "#fff",
                      scrollbarWidth: "thin !important",
                      overflow: "auto !important",
                    }}
                  >
                    <SoftBox
                      display=" flex"
                      flexDirection="column"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      p={1}
                    >
                      <Grid
                        item
                        sm={12}
                        sx={{
                          display: vlCourtView ? "" : "none",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      >
                        <Card
                          sx={{
                            height: "100% !important",
                            backgroundColor: "#e9eef2",
                          }}
                        >
                          <SoftBox
                            display=" flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            p={1}
                          >
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              <SoftTypography
                                sx={{
                                  fontSize: "1rem",
                                  color: "#344767",
                                  paddingLeft: "5px !important",
                                  borderBottom: "1px solid #00000020",
                                  marginBottom: "10px !important",
                                }}
                              >
                                <Icon>live_tv_outlined_icon</Icon> Virtual Court
                              </SoftTypography>
                            </Grid>
                          </SoftBox>
                        </Card>
                      </Grid>
                      <Grid
                        item
                        sm={12}
                        sx={{
                          display: timelineView ? "" : "none",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      >
                        <Card
                          sx={{
                            height: "100% !important",
                            backgroundColor: "#e9eef2",
                          }}
                        >
                          <SoftBox
                            display=" flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            p={1}
                          >
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              <SoftTypography
                                sx={{
                                  fontSize: "1rem",
                                  color: "#344767",
                                  paddingLeft: "5px !important",
                                  borderBottom: "1px solid #00000020",
                                  marginBottom: "10px !important",
                                }}
                              >
                                <Icon>format_list_bulleted_outlined_icon</Icon> Summary
                              </SoftTypography>
                            </Grid>
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              {cachedEvent && cachedEvent.live
                                ? cachedEvent.live.timeline.map((timelineEvent, i) => {
                                    return (
                                      <SoftTypography
                                        className={
                                          !timelineEvent.participant
                                            ? timelineEvent.par
                                              ? "timeline-event-" + timelineEvent.par
                                              : "timeline-event-0"
                                            : "timeline-event-" + timelineEvent.participant
                                        }
                                        key={"timelineEvent-" + i}
                                      >
                                        {timelineEvent.source
                                          ? timelineEvent.source.replace(
                                              timelineEvent.participant == 1
                                                ? cachedEvent.home
                                                : cachedEvent.away,
                                              ""
                                            )
                                          : "-"}
                                      </SoftTypography>
                                    );
                                  })
                                : ""}
                            </Grid>
                            <Grid
                              item
                              sm={12}
                              sx={{
                                top: "45px",
                                height: "calc(100% - 55px)",
                                width: "50%",
                                borderRight: "1px solid rgba(130, 125, 129, 0.62)",
                                position: "absolute",
                              }}
                            >
                              {cachedEvent && cachedEvent.live
                                ? cachedEvent.live.timeline.map((timelineEvent, i) => {
                                    return (
                                      <SoftTypography
                                        sx={{
                                          fontSize: "0.65rem",
                                          textAlign: "right",
                                          marginRight: "-5px",
                                          lineHeight: "19.5px",
                                        }}
                                        key={"timelineEvent-bullet-" + i}
                                      >
                                        <Icon
                                          sx={{
                                            fontSize: "0.65rem",
                                            color:
                                              timelineEvent.participant == 1 ||
                                              timelineEvent.par == 1
                                                ? "rgb(203, 12, 159)"
                                                : "rgba(203, 12, 159, 0.50)",
                                            cursor: "help",
                                            opacity:
                                              !timelineEvent.participant ||
                                              timelineEvent.participant == 0
                                                ? !timelineEvent.par || timelineEvent.par == 0
                                                  ? 0.3
                                                  : 1
                                                : 1,
                                          }}
                                          title={timelineEvent.source}
                                        >
                                          radio_button_checked_outlined_icon{" "}
                                        </Icon>
                                      </SoftTypography>
                                    );
                                  })
                                : ""}
                            </Grid>
                          </SoftBox>
                        </Card>
                      </Grid>
                      <Grid
                        item
                        sm={12}
                        sx={{
                          display: liveStatsView ? "" : "none",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      >
                        <Card
                          sx={{
                            height: "100% !important",
                            backgroundColor: "#e9eef2",
                          }}
                        >
                          <SoftBox
                            display=" flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            p={1}
                          >
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              <SoftTypography
                                sx={{
                                  fontSize: "1rem",
                                  color: "#344767",
                                  paddingLeft: "5px !important",
                                  borderBottom: "1px solid #00000020",
                                  marginBottom: "10px !important",
                                }}
                              >
                                <Icon>data_saver_off_outlined_icon</Icon> Live Stats
                              </SoftTypography>
                            </Grid>
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              {cachedEvent && cachedEvent.live && cachedEvent.live.scoreBoard
                                ? Object.keys(cachedEvent.live.scoreBoard).map((scItem, i) => {
                                    if (
                                      !cachedEvent.live.scoreBoard[scItem] ||
                                      !cachedEvent.live.scoreBoard[scItem].hasOwnProperty("h") ||
                                      cachedEvent.live.scoreBoard[scItem].h == -1
                                    )
                                      return "";
                                    return (
                                      <Grid
                                        container
                                        key={"scoreboard-type-" + i}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginBottom: "5px",
                                          paddingBottom: "15px",
                                          backgroundColor: "#ffffff60",
                                        }}
                                      >
                                        <Grid item sm={12}>
                                          <SoftTypography className={"scoreboard-type"}>
                                            {scItem}
                                          </SoftTypography>
                                        </Grid>
                                        <Grid item sm={12} sx={{ display: "flex" }}>
                                          <Grid
                                            item
                                            sm={6}
                                            sx={{ paddingRight: "2px", paddingLeft: "5px" }}
                                          >
                                            <Grid item sm={12}>
                                              <SoftTypography className={"scoreboard-value"}>
                                                {cachedEvent.live.scoreBoard[scItem].h}
                                              </SoftTypography>
                                            </Grid>
                                            <Grid item sm={12} sx={{ transform: "rotate(180deg)" }}>
                                              <SoftProgress
                                                className="live-stats-bars"
                                                style={{
                                                  height: "5px",
                                                  backgroundColor: "#ffffff80",
                                                }}
                                                variant="contained"
                                                color="info"
                                                value={
                                                  cachedEvent.live.scoreBoard[scItem].h > 0
                                                    ? (100 *
                                                        cachedEvent.live.scoreBoard[scItem].h) /
                                                      (cachedEvent.live.scoreBoard[scItem].h +
                                                        cachedEvent.live.scoreBoard[scItem].g)
                                                    : 0
                                                }
                                              />
                                            </Grid>
                                          </Grid>
                                          <Grid
                                            item
                                            sm={6}
                                            sx={{ paddingLeft: "2px", paddingRight: "5px" }}
                                          >
                                            <Grid item sm={12}>
                                              <SoftTypography className={"scoreboard-value"}>
                                                {cachedEvent.live.scoreBoard[scItem].g}
                                              </SoftTypography>
                                            </Grid>
                                            <Grid item sm={12}>
                                              <SoftProgress
                                                style={{
                                                  height: "5px",
                                                  backgroundColor: "#ffffff80",
                                                }}
                                                variant="contained"
                                                color="success"
                                                value={
                                                  cachedEvent.live.scoreBoard[scItem].g > 0
                                                    ? (100 *
                                                        cachedEvent.live.scoreBoard[scItem].g) /
                                                      (cachedEvent.live.scoreBoard[scItem].h +
                                                        cachedEvent.live.scoreBoard[scItem].g)
                                                    : 0
                                                }
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    );
                                  })
                                : ""}
                            </Grid>
                          </SoftBox>
                        </Card>
                      </Grid>
                    </SoftBox>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props for the DataTable
FixtureTraderView.propTypes = {
  state: PropTypes.object,
};

export default FixtureTraderView;
